// extracted by mini-css-extract-plugin
module.exports = {"aiContainer":"idt-aistudiobutton_aicontainer__2b3dx","aiButton":"idt-aistudiobutton_aibutton__2_lbx"};